import { MapTemplateIcon } from "@/assets/icons";

interface TemplateOverviewModalHeaderProps {
  readonly title: string;
}

export default function TemplateOverviewModalHeader({
  title
}: TemplateOverviewModalHeaderProps) {
  return (
    <div className="flex items-center justify-between w-full bg-teal-50 px-5 rounded-xl h-40">
      <h1 className="text-txtHeading text-base font-semibold">{title}</h1>
      <MapTemplateIcon />
    </div>
  );
}
